export const socialsData = {
  github: "https://github.com/AnupKaphle58",
  facebook: "https://www.facebook.com/guns.2684/",
  linkedIn: "https://np.linkedin.com/in/anup-kafle-69875519a",
  twitter: "https://twitter.com/KaphleAnup",
  mail: "anupkafle02@gmail.com",
};
